import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { SubmitButton } from "../../../lib/Button";
import { CustomRadio } from "../../../lib/CustomRadio";
import { TableColumn, TableWithCollapse } from "../../../lib/DataTable";
import { useTableWithCollapse } from "../../../lib/DataTable/customHooks";
import {
  fetchInvestorDetails,
  sendPhoneOTP,
  updateMultiBankDetails,
} from "../../../store/actions/nct";
import { RootStateType } from "../../../store/reducers";
import { BANK } from "../../../store/types/nct";
import { EQUITY, LIQUID, DEBT, OTHER } from "../../../utils/constants";
import { maskMobileNumber } from "../../../utils/utilityFunctions";
import { findDefaultBank, findDefaultBankIndex } from "../ChangeBank";
import { ConsolidateTableRowType } from "../ConsolidationFolios/types";
import NoFoliosFound from "../NoFoliosFound";
import { BackArrow } from "../UpdateNominee/SelectedFolios";
import {
  getInvestorFunds,
  portfoliosByModeOfHolding,
  portfoliosByTransactionResource,
} from "../portfolios/utils";
import en from "../../../lang/en-us";
import CustomizedSelect from "../transactions/customizedSelect";
import { useMobileEmailFilter } from "../useMobileEmailFilter";
import { groupFilteredData } from "../utils";

const { dashboard } = en;

export const ADD_BANK = "addition";
export const DELETE_BANK = "deletion";
export const CHANGE_DEFALUT = "changeDefaultFlag";

const MenuList = [
  {
    label: dashboard.BankMandate.selectedFolios.radioOption1,
    value: ADD_BANK,
  },
  {
    label: dashboard.BankMandate.selectedFolios.radioOption2,
    value: DELETE_BANK,
  },
  {
    label: dashboard.BankMandate.selectedFolios.radioOption3,
    value: CHANGE_DEFALUT,
  },
];

export const Columns: TableColumn[] = [
  {
    field: "folio",
    headerName: "FOLIO",
  },
  {
    field: "amcName",
    headerName: "Fund House",
    width: 250,
    filterBy: true,
    filterHeader: "Fund House",
    filterKey: "amcName",
  },
  {
    field: "bank",
    headerName: "DEFAULT BANK",
    valueGetter: ({ row }) =>
      findDefaultBank(row)?.name || dashboard.notAvailable,
    width: 200,
  },
  {
    field: "accountNo",
    headerName: "ACCOUNT NUMBER",
    valueGetter: ({ row }) =>
      maskMobileNumber(findDefaultBank(row)?.accountNo) ||
      dashboard.notAvailable,
    width: 200,
  },
  {
    field: "investorName",
    headerName: "PRIMARY HOLDER",
    valueGetter: ({ row }) =>
      (row?.investorName || "").toUpperCase() || dashboard.notAvailable,
    width: 100,
  },
  {
    isFilter: true,
    field: "assetType",
    headerName: "Category",
    filterBy: true,
    renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
  },
];
function BankMandate(props: any) {
  const [rowData, setRowdata] = useState<ConsolidateTableRowType[]>([]);
  const { filterState, setGroupFilterMap, filterDispatch } =
    useMobileEmailFilter(rowData);
  const { emailMobileKeys, currentKey, groupedFilterMap } = filterState;
  const [loading, setLoading] = useState<boolean>(false);
  const [actionType, setActionType] = useState<string | undefined>(ADD_BANK);
  const {
    selectedRows: targetFunds,
    setSelectedRows: setTargetFunds,
    resetTable,
    resetFilters,
    tableColumns,
    tableRows,
    ...filters
  } = useTableWithCollapse<ConsolidateTableRowType[]>({
    rows: currentKey ? groupedFilterMap[currentKey] : rowData,
    columns: Columns,
    loading,
  });

  useEffect(() => {
    setLoading(true);
    async function callApi() {
      const payload = {
        pan: props.investorData.PAN,
        brokercode: props.token,
      };
      try {
        const { body: investorDetails = {} } = await props.fetchInvestorDetails(
          payload
        );
        const { success: investorFundDetails = [] } = investorDetails;
        const bankFundRowData = getInvestorFunds(investorFundDetails, [
          portfoliosByTransactionResource,
          portfoliosByModeOfHolding,
          ({ banks = [] }: ConsolidateTableRowType): boolean =>
            banks.findIndex(
              (details: BANK) =>
                details.default === "Y" || details.default === ""
            ) !== -1,
        ]);
        setRowdata(bankFundRowData);
      } catch (err: any) {
        alert(err.message);
      } finally {
        setLoading(false);
      }
    }
    callApi();
    return () => {};
  }, []);

  useEffect(() => {
    setTargetFunds([]);
  }, [currentKey]);

  useEffect(() => {
    if (rowData.length > 0) {
      const groupedFilterMap = groupFilteredData(rowData);
      setGroupFilterMap(groupedFilterMap);
    }
  }, [rowData]);

  const handleFilterKeyChange = (e: any) => {
    filterDispatch({
      type: "SET_FILTER_KEY",
      payload: e.target.value,
    });
  };

  useEffect(() => {
    resetFilters();
    setTargetFunds([]);
  }, [actionType]);

  const _isRowSeletable = ({ row }: { row: ConsolidateTableRowType }) => {
    const { banks = [] } = row;
    if (banks.length === 1 && actionType !== ADD_BANK) {
      return false;
    }
    if (actionType === ADD_BANK && targetFunds.length) {
      const [fund] = targetFunds;

      const rowDefaultBankIndex = findDefaultBankIndex(row);
      const fundDefaultBankIndex = findDefaultBankIndex(fund);

      const bankIfsc = fund.banks[fundDefaultBankIndex]?.ifsc?.toUpperCase();
      const rowIfsc = row.banks[fundDefaultBankIndex]?.ifsc?.toUpperCase();

      const accountNo = fund.banks[rowDefaultBankIndex]?.accountNo;
      const rowAccountNo = row.banks[rowDefaultBankIndex]?.accountNo;

      if (!(bankIfsc === rowIfsc && accountNo === rowAccountNo)) {
        return false;
      }
    }
    return true;
  };

  const _toolTipGetText = ({ row }: { row: ConsolidateTableRowType }) => {
    const { banks = [] } = row;
    if (banks.length === 1 && actionType !== ADD_BANK) {
      return dashboard.BankMandate.toolTipText;
    }
    if (actionType === ADD_BANK && targetFunds.length) {
      const [fund] = targetFunds;

      const rowDefaultBankIndex = findDefaultBankIndex(row);
      const fundDefaultBankIndex = findDefaultBankIndex(fund);

      const bankIfsc = fund.banks[fundDefaultBankIndex]?.ifsc?.toUpperCase() || fund.banks[fundDefaultBankIndex]?.ifsccode?.toUpperCase();
      const rowIfsc = row.banks[fundDefaultBankIndex]?.ifsc?.toUpperCase() || row.banks[fundDefaultBankIndex]?.ifsccode?.toUpperCase();

      const accountNo = fund.banks[rowDefaultBankIndex]?.accountNo;
      const rowAccountNo = row.banks[rowDefaultBankIndex]?.accountNo;

      if (!(bankIfsc === rowIfsc && accountNo === rowAccountNo)) {
        return dashboard.ChangeBank.tooltip.info1;
      }
    }
    return "";
  };

  const handleSubmit = async () => {
    if (actionType === ADD_BANK) {
      props.history.push("bank-mandate-add-bank", {
        targetFunds,
        actionType,
        addBank: true,
      });
      return;
    }
    props.history.push("bank-mandate-delete-selected", {
      targetFunds: targetFunds.map((tf) => ({
        ...tf,
        banks: tf.banks.map((bank) => ({
          ...bank,
          ifsc: bank?.ifsccode || bank?.ifsc,
        })),
      })),
      actionType,
      addBank: false,
    });
    setTargetFunds([]);
  };

  return (
    <div className="curved-bg">
      <BackArrow history={props.history} />
      {tableRows.length > 0 && currentKey && (
        <div
          className="appbar-div dual-margin input-name-responsive"
          style={{ display: "flex", gap: "1%" }}
        >
          <div
            className="input-name input-name-sizing-responsive"
            style={{ alignItems: "center", display: "flex", marginBottom: "0" }}
          >
            Select Email-Mobile Combination
          </div>
          <CustomizedSelect
            handleChange={handleFilterKeyChange}
            value={currentKey}
            emailStyle={true}
          >
            {emailMobileKeys &&
              emailMobileKeys.map((item) => (
                <MenuItem value={item} key={item}>
                  {item}
                </MenuItem>
              ))}
          </CustomizedSelect>
        </div>
      )}
      <div className="curved-bg-content curved-bg-table-outer">
        <div className="curved-bg-content-table">
          <CustomRadio
            extraClass="custom-radio desktop_mode"
            title={dashboard.BankMandate.selectOption}
            name="select-dividend"
            list={MenuList}
            selectedValue={actionType}
            handleRadioChange={(value: string) => setActionType(value)}
          />
          <FormControl variant="filled" className="mobile_mode">
            <InputLabel id="change-bank-mandate-option-label">
              {dashboard.BankMandate.selectOption}
            </InputLabel>
            <Select
              labelId="change-bank-mandate-option-label"
              id="change-bank-mandate-option"
              value={actionType}
              onChange={(e: any) => setActionType(e.target.value)}
            >
              {MenuList.map((item) => (
                <MenuItem key={item.label} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <h5> {dashboard.BankMandate.BankMandateInfo}</h5>
          <div className="curved-table-content">
            {(!loading && !tableRows.length) || !currentKey ? (
              <NoFoliosFound />
            ) : (
              <TableWithCollapse
                rows={tableRows}
                columns={tableColumns}
                toolTipEnabled
                checkBoxEnabled
                disableAllSelection
                isRowSelectable={_isRowSeletable}
                toolTipTextGetter={_toolTipGetText}
                selectedRows={targetFunds}
                setSelectedRows={setTargetFunds}
                resetFilters={resetFilters}
                {...filters}
              />
            )}
          </div>
        </div>
        <div className="curved-bg-content-inner-bottom">
          {!!rowData.length && (
            <div className="table-submit">
              <SubmitButton
                disabled={!targetFunds.length}
                onClick={handleSubmit}
                label={dashboard.BankMandate.buttonText}
                className="customBtn"
              />
            </div>
          )}
        </div>
      </div>
      {/* <NoteModals
                showModal={show}
                heading={dashboard.BankMandate.noteModals.heading}
                info={dashboard.BankMandate.noteModals.info}
                proceedBtn={dashboard.BankMandate.noteModals.proceedText}
                cancelBtn={dashboard.BankMandate.noteModals.cancelText}
            /> */}
    </div>
  );
}
export default connect(
  ({ authReducer }: RootStateType) => ({ ...authReducer }),
  {
    fetchInvestorDetails,
    updateMultiBankDetails,
    sendPhoneOTP,
  }
)(BankMandate);
